/**
 *	Tracks JS errors and sends a report to the server.
 */
window.onerror	=	function (message, source, lineno, colno, error) {
	
	if (typeof message === 'undefined')	var message	=	'';
	if (typeof source === 'undefined')	var source	=	'';
	if (typeof lineno === 'undefined')	var lineno	=	0;
	if (typeof colno === 'undefined')	var colno	=	0;
	
	var stack	=	'';
	
	if (typeof error === 'object' && typeof error.stack === 'string')	stack	=	error.stack;
	
	$.ajax({
		url			:	'/library/php/capture-js-error.php',
		type		:	'post',
		dataType	:	'json',
		data		:	{
			je_message	:	message,
			je_source	:	source,
			je_lineno	:	lineno,
			je_colno	:	colno,
			je_url		:	window.location.href,
			je_stack	:	stack
		}
	});
	
};


/*!
 * backgroundSize: A jQuery cssHook adding support for "cover" and "contain" to IE6,7,8
 *
 * Requirements:
 * - jQuery 1.7.0+
 *
 * Limitations:
 * - doesn't work with multiple backgrounds (use the :after trick)
 * - doesn't work with the "4 values syntax" of background-position
 * - doesn't work with lengths in background-position (only percentages and keywords)
 * - doesn't work with "background-repeat: repeat;"
 * - doesn't work with non-default values of background-clip/origin/attachment/scroll
 * - you should still test your website in IE!
 *
 * latest version and complete README available on Github:
 * https://github.com/louisremi/jquery.backgroundSize.js
 *
 * Copyright 2012 @louis_remi
 * Licensed under the MIT license.
 *
 * This saved you an hour of work?
 * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
 *
 */
(function(k,m,n,d,f){var b=k("<div>")[0],h=/url\(["']?(.*?)["']?\)/,l=[],j={top:0,left:0,bottom:1,right:1,center:0.5};if("backgroundSize" in b.style&&!k.debugBGS){return}k.cssHooks.backgroundSize={set:function(q,s){var u=!k.data(q,"bgsImg"),t,r,p;k.data(q,"bgsValue",s);if(u){l.push(q);k.refreshBackgroundDimensions(q,true);r=k("<div>").css({position:"absolute",zIndex:-1,top:0,right:0,left:0,bottom:0,overflow:"hidden"});p=k("<img>").css({position:"absolute"}).appendTo(r),r.prependTo(q);k.data(q,"bgsImg",p[0]);t=(k.css(q,"backgroundPosition")||k.css(q,"backgroundPositionX")+" "+k.css(q,"backgroundPositionY")).split(" ");k.data(q,"bgsPos",[j[t[0]]||parseFloat(t[0])/100,j[t[1]]||parseFloat(t[1])/100]);k.css(q,"zIndex")=="auto"&&(q.style.zIndex=0);k.css(q,"position")=="static"&&(q.style.position="relative");k.refreshBackgroundImage(q)}else{k.refreshBackground(q)}},get:function(p){return k.data(p,"bgsValue")||""}};k.cssHooks.backgroundImage={set:function(p,q){return k.data(p,"bgsImg")?k.refreshBackgroundImage(p,q):q}};k.refreshBackgroundDimensions=function(s,q){var p=k(s),r={width:p.innerWidth(),height:p.innerHeight()},u=k.data(s,"bgsDim"),t=!u||r.width!=u.width||r.height!=u.height;k.data(s,"bgsDim",r);if(t&&!q){k.refreshBackground(s)}};k.refreshBackgroundImage=function(t,u){var r=k.data(t,"bgsImg"),s=(h.exec(u||k.css(t,"backgroundImage"))||[])[1],w=r&&r.src,v=s!=w,q,p;if(v){r.style.height=r.style.width="auto";r.onload=function(){var x={width:r.width,height:r.height};if(x.width==1&&x.height==1){return}k.data(t,"bgsImgDim",x);k.data(t,"bgsConstrain",false);k.refreshBackground(t);r.style.visibility="visible";r.onload=null};r.style.visibility="hidden";r.src=s;if(r.readyState||r.complete){r.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";r.src=s}t.style.backgroundImage="none"}};k.refreshBackground=function(r){var x=k.data(r,"bgsValue"),s=k.data(r,"bgsDim"),t=k.data(r,"bgsImgDim"),p=k(k.data(r,"bgsImg")),w=k.data(r,"bgsPos"),u=k.data(r,"bgsConstrain"),v,z=s.width/s.height,q=t.width/t.height,y;if(x=="contain"){if(q>z){k.data(r,"bgsConstrain",(v="width"));y=d.floor((s.height-s.width/q)*w[1]);p.css({top:y});if(v!=u){p.css({width:"100%",height:"auto",left:0})}}else{k.data(r,"bgsConstrain",(v="height"));y=d.floor((s.width-s.height*q)*w[0]);p.css({left:y});if(v!=u){p.css({height:"100%",width:"auto",top:0})}}}else{if(x=="cover"){if(q>z){k.data(r,"bgsConstrain",(v="height"));y=d.floor((s.height*q-s.width)*w[0]);p.css({left:-y});if(v!=u){p.css({height:"100%",width:"auto",top:0})}}else{k.data(r,"bgsConstrain",(v="width"));y=d.floor((s.width/q-s.height)*w[1]);p.css({top:-y});if(v!=u){p.css({width:"100%",height:"auto",left:0})}}}}};var a=k.event,c,g={_:0},e=0,i,o;c=a.special.throttledresize={setup:function(){k(this).on("resize",c.handler)},teardown:function(){k(this).off("resize",c.handler)},handler:function(s,p){var r=this,q=arguments;i=true;if(!o){k(g).animate(g,{duration:Infinity,step:function(){e++;if(e>c.threshold&&i||p){s.type="throttledresize";a.dispatch.apply(r,q);i=false;e=0}if(e>9){k(g).stop();o=false;e=0}}});o=true}},threshold:1};k(m).on("throttledresize",function(){k(l).each(function(){k.refreshBackgroundDimensions(this)})})})(jQuery,window,document,Math);





//add global easing method
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend( jQuery.easing,
{
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	}
});




(function($) {

var types = ['DOMMouseScroll', 'mousewheel'];

if ($.event.fixHooks) {
    for ( var i=types.length; i; ) {
        $.event.fixHooks[ types[--i] ] = $.event.mouseHooks;
    }
}

$.event.special.mousewheel = {
    setup: function() {
        if ( this.addEventListener ) {
            for ( var i=types.length; i; ) {
                this.addEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = handler;
        }
    },
    
    teardown: function() {
        if ( this.removeEventListener ) {
            for ( var i=types.length; i; ) {
                this.removeEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = null;
        }
    }
};

$.fn.extend({
    mousewheel: function(fn) {
        return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },
    
    unmousewheel: function(fn) {
        return this.unbind("mousewheel", fn);
    }
});


function handler(event) {
    var orgEvent = event || window.event, args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";
    
    // Old school scrollwheel delta
    if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta/120; }
    if ( orgEvent.detail     ) { delta = -orgEvent.detail/3; }
    
    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;
    
    // Gecko
    if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
        deltaY = 0;
        deltaX = -1*delta;
    }
    
    // Webkit
    if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
    if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }
    
    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);
    
    return ($.event.dispatch || $.event.handle).apply(this, args);
}

})(jQuery);









/*! jQuery requestAnimationFrame - v0.1.2 - 2013-04-15
* https://github.com/gnarf37/jquery-requestAnimationFrame
* Copyright (c) 2013 Corey Frang; Licensed MIT */
(function(e){function o(){t&&(i(o),jQuery.fx.tick())}var t,n=0,r=["webkit","moz"],i=window.requestAnimationFrame,s=window.cancelAnimationFrame;for(;n<r.length&&!i;n++)i=window[r[n]+"RequestAnimationFrame"],s=s||window[r[n]+"CancelAnimationFrame"]||window[r[n]+"CancelRequestAnimationFrame"];i?(window.requestAnimationFrame=i,window.cancelAnimationFrame=s,jQuery.fx.timer=function(e){e()&&jQuery.timers.push(e)&&!t&&(t=!0,o())},jQuery.fx.stop=function(){t=!1}):(window.requestAnimationFrame=function(e,t){var r=(new Date).getTime(),i=Math.max(0,16-(r-n)),s=window.setTimeout(function(){e(r+i)},i);return n=r+i,s},window.cancelAnimationFrame=function(e){clearTimeout(e)})})(jQuery);











//requestAnimationFrame browser extensions / fallback
(function() {
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame = 
		  window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}
 
	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
			  timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
 
	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
}());









/*
By Osvaldas Valutis, www.osvaldas.info
Available for use under the MIT License
*/
;( function( $, window, document, undefined )
{
var s = document.body || document.documentElement, s = s.style, prefixAnimation = '', prefixTransition = '';

if( s.WebkitAnimation == '' )	prefixAnimation	 = '-webkit-';
if( s.MozAnimation == '' )		prefixAnimation	 = '-moz-';
if( s.OAnimation == '' )		prefixAnimation	 = '-o-';

if( s.WebkitTransition == '' )	prefixTransition = '-webkit-';
if( s.MozTransition == '' )		prefixTransition = '-moz-';
if( s.OTransition == '' )		prefixTransition = '-o-';

$.fn.extend(
{
	onCSSAnimationEnd: function( callback )
	{
		var $this = $( this ).eq( 0 );
		$this.one( 'webkitAnimationEnd mozAnimationEnd oAnimationEnd oanimationend animationend', callback );
		if( ( prefixAnimation == '' && !( 'animation' in s ) ) || $this.css( prefixAnimation + 'animation-duration' ) == '0s' ) callback();
		return this;
	},
	onCSSTransitionEnd: function( callback )
	{
		var $this = $( this ).eq( 0 );
		$this.one( 'webkitTransitionEnd mozTransitionEnd oTransitionEnd otransitionend transitionend', callback );
		if( ( prefixTransition == '' && !( 'transition' in s ) ) || $this.css( prefixTransition + 'transition-duration' ) == '0s' ) callback();
		return this;
	}
});
})( jQuery, window, document );









/*!
 * Copyright (C) 2015, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * 
 * Name			: pepResponsive
 * Description	: Set break-points and callbacks for specific elements to allow
 * 				  for a responsive design with easy-to-use CSS.
 * Changes		: 10/28/2013
 * 					- Handles callback function for each element in the set
 * 					- Utalizes the ui-widescreen class properly now
 * 					- New options to set cookie and throttle resize event handler
 *
 * 				2016-09-13
 * 					- Fixed sub-pixel translation for instagram images making caption text blurry.
 *
 * 				2024-03-14
 * 					- Fix window reference for webpack build process in main.js.
 */
(function ($) {
	$.fn.pepResponsive	= function (opts) {
		//NOTE: `this` is a jQuery collection
		
		var $this		= this,
			defaults	= {
				current			: 'ui-desktop',			//ui class (string)
				points			: [ 767, 1024, 1280 ],											//needs to match number of "classes" (array of integers)
				classes			: [ 'ui-mobile', 'ui-tablet', 'ui-desktop', 'ui-widescreen' ],	//needs to match number of "points" (array of strings)
				orientation		: 'landscape',			//"portrait" or "landscape" (string)
				callback		: function () {},		//(function)
				watchEle		: $(window),				//selector (string)
				throttleTimeout	: 100,					//throttle timeout in milliseconds (integer)
				setCookie		: true
			},
			options		= $.extend({}, defaults, opts),
			$html		= $("html"),
			timer		= null,
			dims		= {
				width	: 0,
				height	: 0
			};

		//check which ui the server decided to utilize (based on cookie or intelligent guess)
		for (var i = 0, l = options.classes.length; i < l; i++) {
			if ($html.hasClass(options.classes[i])) {
				options.current	= options.classes[i];
				break;
			}
		}
		
		//setup event handler for current element
		options.watchEle.on("resize.pepResponsive", function () {
			clearTimeout(timer);
			timer	= setTimeout(function () {
				
				//cache "old" options
				var oldOptions	= {
						current		: options.current,
						orientation	: options.orientation
					};
				
				//set new dimensions
				dims.width	= options.watchEle.width();
				dims.height	= options.watchEle.height();
				
				//determine which responsive-design-break-point should be used
				var found	= false;
				for (var i = 0, l = options.points.length; i < l; i++) {
					if (dims.width <= options.points[i]) {
						found	= true;
						break;
					}
				}
				
				//if no match was found then use largest
				if (found === false) {
					i = l;
				}
				
				//update orientation class
				if (dims.width > dims.height) {
					options.orientation	= 'landscape';
				} else {
					options.orientation	= 'portrait';
				}
				
				//update the watch element
				options.current	= options.classes[i];
				
				//update cookie if necessary
				if (options.setCookie === true) {
					document.cookie = "responsive=" + options.current + "; path=/;";
				}
				
				//loop through selected elements
				for (var i = 0, l = $this.length; i < l; i++) {
					
					//set orientation class
					$this.eq(i).removeClass("portrait landscape").addClass(options.orientation);
					
					//set ui class
					$this.eq(i).removeClass(options.classes.join(" ")).addClass(options.current);
					
					//save options to element
					$this.eq(0).data("pepResponsive", options);
					
					//run callback function
					options.callback.call($this[i], options, oldOptions);
				}
			}, options.throttleTimeout);
		}).trigger("resize.pepResponsive");
		
		//return `this` for method chaining
		return this;
	};
})(jQuery);









/*!
 * Copyright (C) 2015-2016, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * PeppermillLasVegase.com Custom JS
 * Version: 1.1.0
 * Changes:
 *	2015-07-27
 *			- Initial Install
 *
 *	2016-05-03 (1.1.0)
 *			- Added code to track JS errors.
 */

(function ($) {
	
	var $bodyContainers				=	$('#content').children('.body-container'),
		currentScrollPosition		=	$(window).scrollTop(),
		lastRenderScrollPosition	=	-1,
		currentWindowHeight			=	$(window).height(),
		currentWindowWidth			=	$(window).width(),
		currentHeaderHeight			=	$('#header').outerHeight(),
		loadEventFired				=	false,
		currentBodyContainerHeights	=	[],
		lastRenderWindowHeight		=	-1,
		enableParalaxScroll			=	false,
		enableSwooshOpacityScroll	=	true,//Modernizr.backgroundsize,
		bgPositionRenderCoefficient	=	0.1,
		activateNavButtonsOnScroll	=	true,
		pageTitlePrefix				=	$('title').data('title-prefix'),
		pageTitleSuffix				=	$('title').data('title-suffix'),
		initializeFunctionTimer		=	null,
		initializeFunction			=	function () {
			
			clearTimeout(initializeFunctionTimer);
			
			loadEventFired	=	true;
			
			if (initializePageImagesOnLoad) {
				
				initializePageImages();
				
			}
			
			initializeFunctionTimer	=	setTimeout(function () {
				
				currentScrollPosition		=	$(this).scrollTop();
				currentWindowHeight			=	$(this).height();
				currentWindowWidth			=	$(this).width();
				currentHeaderHeight			=	$('#header').outerHeight();
				lastRenderedScrollPosition	=	-1;
				currentBodyContainerHeights	=	[];
				
				$.each($bodyContainers, function () {
					
					currentBodyContainerHeights.push($(this).height());
					
				});
				
				if (!Modernizr.cssvhunit) {
					
					$('.body-spacer').css('height', currentWindowHeight * 0.75);
					
				}
				
				var $openGalleries	=	$('#container').children('.gallery-wrapper');
				
				if ($openGalleries.length) {
					
					$openGalleries
						.children('.prev-item').css(galleryCreateItemCSS('prev')).end()
						.children('.current-item').css(galleryCreateItemCSS('current')).end()
						.children('.next-item').css(galleryCreateItemCSS('next'));
					
				}
				
				if (!$('html').hasClass('ui-mobile')) {
					
					$.each($bodyContainers.filter('[data-bg-image]'), function () {
						
						$(this).css({
							backgroundImage		:	'url(' + $(this).data('bg-image') + ')',
							backgroundPosition	:	$(this).data('bg-x') + '% ' + $(this).data('bg-y') + '%'
						});
						
					});
					
				}
				
			}, 100);
			
		},
		scrollEndFunction			=	function () {
			
			if (!history.pushState) return;
			
			var $activeNavButton	=	$('#nav').find('a').filter('.active');
			
			if ($activeNavButton.length && location.pathname !== $activeNavButton.attr('href')) {
				
				history.pushState({ url : $activeNavButton.attr('href') }, pageTitlePrefix + $activeNavButton.text() + pageTitleSuffix, $activeNavButton.attr('href'));
				
				$('title').eq(0).text(pageTitlePrefix + $activeNavButton.text() + pageTitleSuffix);
				
				if ('ga' in window) {
          window.ga('send', 'pageview', $activeNavButton.attr('href'));
        }
        if ('gtag' in window) {
          window.gtag('event', 'page_view', {page_location: $activeNavButton.attr('href')});
        }
				
			} else if ($activeNavButton.length === 0 && location.pathname !== '/') {
				
				history.pushState({ url : '/' }, pageTitlePrefix + 'Home' + pageTitleSuffix, '/');
				
				$('title').eq(0).text(pageTitlePrefix + 'Home' + pageTitleSuffix);
				
				if ('ga' in window) {
          window.ga('send', 'pageview', $activeNavButton.attr('href'));
        }
        if ('gtag' in window) {
          window.gtag('event', 'page_view', {page_location: $activeNavButton.attr('href')});
        }
				
			}
			
		},
		scrollEndTimer,
		scrollRequestID,
		initializePageImagesOnLoad	=	false,
		initializePageImages		=	function (bodyIndex) {
			
			if (loadEventFired) {
				
				$.each($bodyContainers.eq(bodyIndex).children('.body').find('.photo-grid').children('.item'), function () {
					
					$(this).css('background-image', 'url(' + $(this).data('thumbnail') + ')');
					
				});
				
			} else {
				
				initializePageImagesOnLoad	=	true;
				
			}
			
		},
		isOldIE						=	false;
	
	function getInternetExplorerVersion() {
		var rv = -1; // Return value assumes failure.
		if (navigator.appName == 'Microsoft Internet Explorer') {
			var ua = navigator.userAgent;
			var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
			if (re.exec(ua) != null)
			rv = parseFloat( RegExp.$1 );
		}
		return rv;
	}
	
	if (getInternetExplorerVersion() > -1 && getInternetExplorerVersion() < 9) {
		
		isOldIE	=	true;
		
	}
	
	
	
	if (!Modernizr.backgroundsize) {
	
		$('#left-side-overlay').css('background-size', 'cover').children('.swoosh').css('background-size', 'cover');
		
	}
	
	
	
	//initiailize responsive code
	$('html').pepResponsive({
		callback	:	function ($ele, opts) {
			/*
			if ((opts.current === 'ui-desktop' || opts.current === 'ui-widescreen') && !Modernizr.touch) {
				
				enableParalaxScroll	=	true;
				
			} else {
				
				enableParalaxScroll	=	false;
				
			}
			*/
		}
	});
	
	
	
	
	
	//setup scroll handler
	$(window).on('scroll', function () {
		
		currentScrollPosition	=	$(this).scrollTop();
		
		clearTimeout(scrollEndTimer);
		scrollEndTimer			=	setTimeout(scrollEndFunction, 1000);
		
	}).on('load resize', initializeFunction);
	
	initializeFunction();
	
	
	
	//setup redraw functionality
	function render() {
		
		if (lastRenderScrollPosition !== currentScrollPosition || lastRenderWindowHeight !== currentWindowHeight) {
			
			var totalHeight		=	0,
				direction		=	(lastRenderScrollPosition > currentScrollPosition)
										?	-1
										:	1,
				navButton		=	-1;

			lastRenderScrollPosition	=	currentScrollPosition;
			lastRenderWindowHeight		=	currentWindowHeight;
			
			$.each($bodyContainers, function (index) {
				
				var thisBodyTop	=	totalHeight;
				
				totalHeight	+=	currentBodyContainerHeights[index] || $(this).height();
				
				var newOpacity	=	(totalHeight - currentScrollPosition) / currentWindowHeight * 0.75;
				
				if (newOpacity <= 1) {
					
					if (enableSwooshOpacityScroll && currentScrollPosition + currentWindowHeight > totalHeight) {
						
						$('#left-side-overlay').children('.swoosh').eq(index + Math.abs(direction)).css({
							opacity	:	1 - ((totalHeight - currentScrollPosition) / currentWindowHeight)
						});
						
					}
					
					if (enableParalaxScroll) {
						
						var percentScrolledForPage	=	(currentScrollPosition + currentWindowHeight - totalHeight) / currentWindowHeight * 100,
							yPercentage				=	parseInt($bodyContainers.eq(index).data('bg-y'), 10) + (percentScrolledForPage * bgPositionRenderCoefficient);
						
						if (yPercentage > 100) {
							
							yPercentage	=	100;
							
						} else if (yPercentage < 0) {
							
							yPercentage	=	0;
							
						}
						
						$bodyContainers.eq(index).css('background-position', $bodyContainers.eq(index).data('bg-x') + '% ' + yPercentage + '%');
						
					}
					
				} else if (enableSwooshOpacityScroll) {
					
					$('#left-side-overlay').children('.swoosh').eq(index + Math.abs(direction)).css({
						opacity	:	0
					});
					
					//if (direction === 1 && newOpacity < 1.5) {
						
					//	navButton	=	index;
						
					//} else if (direction === -1 && newOpacity > 1.5 && navButton === -1 && index > 0) {
						
					//	navButton	=	index - 1;
						
					//}
					
				}
				
				if (thisBodyTop - currentHeaderHeight <= currentScrollPosition) {
					
					navButton	=	index;
					
					//load gallery thumbnails for this page if needed
					if (!$(this).data('gallery-initialized')) {
						
						initializePageImages(index);
						
					}
					
					//make sure to only initialize galleries once
					$(this).data('gallery-initialized', true);
					
				}
				
			});
			
			if (navButton !== -1 && activateNavButtonsOnScroll) {
				
				$('#nav').find('a').removeClass('active');
				
				if (navButton > 0) {
					
					$('#nav').find('a').eq(navButton - 1).addClass('active');
					
					//history.pushState({ url : $('#nav').find('a').eq(navButton - 1).attr('href') }, pageTitlePrefix + $('#nav').find('a').eq(navButton - 1).text() + pageTitleSuffix, $('#nav').find('a').eq(navButton - 1).attr('href'));
					
					//$('title').eq(0).text(pageTitlePrefix + $('#nav').find('a').eq(navButton - 1).text() + pageTitleSuffix);
					
				} else {
					
					//history.pushState({ url : '/' }, pageTitlePrefix + 'Home' + pageTitleSuffix, '/');
					
					//$('title').eq(0).text(pageTitlePrefix + 'Home' + pageTitleSuffix);
					
				}
				
			}
			
		}
		
		scrollRequestID	=	requestAnimationFrame(render);
		
	}
	
	scrollRequestID	=	requestAnimationFrame(render);
	
	
	
	
	
	//main nav functionality
	$('#header').find('.logo').on('click', function (event, doNotAnimate, doNotSaveState) {
		
		event.preventDefault();
		
		if (!doNotSaveState && Modernizr.history) {
			
			history.pushState({ url : '/' }, pageTitlePrefix + 'Home' + pageTitleSuffix, '/');
			
			$('title').eq(0).text(pageTitlePrefix + 'Home' + pageTitleSuffix);
			
			if ('ga' in window) {
        window.ga('send', 'pageview', '/');
      }
      if ('gtag' in window) {
        window.gtag('event', 'page_view', {page_location: '/'});
      }
			
		}
		
		if (doNotAnimate) {
			
			$('html, body').scrollTop($bodyContainers.eq(0).offset().top);
			
		} else {
			
			activateNavButtonsOnScroll	=	false;
			
			$('#nav').find('a').removeClass('active');
			
			$('html, body').animate({ scrollTop : $bodyContainers.eq(0).offset().top }, 550, 'easeOutCubic', function () {
				
				activateNavButtonsOnScroll	=	true;
				
			});
			
		}
		
	});
	
	$('#nav').find('a').on('click', function (event, doNotAnimate, doNotSaveState) {
		
		event.preventDefault();
		
		//check if a gallery or menu is open, if so close it
		if ($('#container').children('.iframe-wrapper, .gallery-wrapper').length) {
			
			$('#container').children('.iframe-wrapper, .gallery-wrapper').children('.close').trigger('click');
			
		}
		
		var $link	=	$(this);
		
		if (!doNotSaveState && Modernizr.history) {
			
			history.pushState({ url : $link.attr('href') }, pageTitlePrefix + $link.text() + pageTitleSuffix, $link.attr('href'));
			
			$('title').eq(0).text(pageTitlePrefix + $link.text() + pageTitleSuffix);
			
			if ('ga' in window) {
        window.ga('send', 'pageview', $link.attr('href'));
      }
      if ('gtag' in window) {
        window.gtag('event', 'page_view', {page_location: $link.attr('href')});
      }
			
		}
		
		if (doNotAnimate) {
			
			$('html, body').scrollTop($bodyContainers.eq($link.index() + 1).offset().top);
			
		} else {
			
			activateNavButtonsOnScroll	=	false;
			
			$link.addClass('active').siblings().removeClass('active');
			
			$('html, body').animate({ scrollTop : $bodyContainers.eq($link.index() + 1).offset().top }, 550, 'easeOutCubic', function () {
				
				activateNavButtonsOnScroll	=	true;
				
			});
			
		}
		
	});
	
	$(window).on('popstate', function (event) {
		
		if (typeof event.originalEvent.state === 'object' && typeof event.originalEvent.state.url === 'string') {
			
			if (event.originalEvent.state.url === '/') {
				
				$('#header').find('.logo').trigger('click', [false, true]);
				
			} else {
			
				$('#nav').find('a').filter('[href="' + event.originalEvent.state.url + '"]').trigger('click', [false, true]);
				
			}
			
		}
		
	});
	
	if (location.pathname.replace(/\//g, '') !== '' && $(window).scrollTop() === 0) {
		
		$('#nav').find('a').filter('[href="/' + location.pathname.replace(/\//g, '') + '"]').trigger('click', [true, true]);
		
	}
	
	
	
	
	
	$('.menu-link').on('click', function (event) {
		
		if (!isOldIE) {
			
			event.preventDefault();
			
			var $wrapperEle	=	$('<div class="iframe-wrapper" />')
									.append('<iframe frameborder="0" src="' + $(this).data('preview') + '" />')
									.append(
										$('<a class="close" href="#" />').on('click', function (event) {
											
											event.preventDefault();
											
											$wrapperEle.onCSSTransitionEnd(function () {
												
												$wrapperEle.remove();
												
												$('html').removeClass('scrollbar-hide');
												
												$('body').height('');
												
											});
											
											$('html').removeClass('iframe-wrapper-show');
											
										})
									);
			
			$('#container').append($wrapperEle);
			
			requestAnimationFrame(function () {
				
				$('body').height($('#content').height());
				
				$('html').addClass('iframe-wrapper-show scrollbar-hide');
				
			});
			
		}
		
	});
	
	$(document).on('keydown', function (event) {
		
		if (event.which === 27) {
			
			$('#container').children('.iframe-wrapper, .gallery-wrapper').children('.close').trigger('click');
			
		}
		
	});
	
	
	
	
	
	
	//Text Size Code
	//Track the change in height/offset of the page and re-scroll to keep what the user is looking at in the viewport.
	$('#content').find('.text-size-btn').on('click', function (event) {
		
		event.preventDefault();
		
		var saveOffset	=	($('#nav').children('.active').length)
								?	$bodyContainers.eq($('#nav').children('.active').index() + 1).offset().top
								:	0,
			addition	=	0;
		
		if (!$('html').hasClass('text-increase')) {
			
			addition	=	1;
			
			//go big
			$('html').addClass('text-increase');
			
			document.cookie = 'text-size=text-increase; path=/;';
			
			window.pepTracking.event('Text Size', 'Increase', window.location.pathname, 0, false);
			
		} else {
			
			//go normal
			$('html').removeClass('text-increase');
			
			document.cookie = 'text-size=; path=/;';
			
			window.pepTracking.event('Text Size', 'Normal', window.location.pathname, 0, false);
			
		}
		
		requestAnimationFrame(function () {
			
			var newOffset	=	($('#nav').children('.active').length)
									?	$bodyContainers.eq($('#nav').children('.active').index() + 1).offset().top
									:	0;
			
			$(window).scrollTop($(window).scrollTop() - saveOffset + newOffset + addition);
			
		});
		
	});
	
	
	
	
	
	
	//photo gallery code
	function galleryCalcItemDimensions() {
		
		return {
			width		:	Math.min(currentWindowHeight / 1.5, currentWindowWidth),
			height		:	Math.min(currentWindowHeight / 1.5, currentWindowWidth)
		}
		
	}
	
	function galleryDetermineTranslation(amplitudeX, amplitudeY) {
		
		if (Modernizr.csstransforms3d) {
			
			return {
				transform	:	'translate3d(' + Math.floor(amplitudeX) + 'px, ' + Math.floor(amplitudeY) + 'px, 0px)'
			}
			
		} else if (Modernizr.csstransforms) {
			
			return {
				transform	:	'translateX(' + Math.floor(amplitudeX) + 'px) translateY(' + Math.floor(amplitudeY) + 'px)'
			}
			
		}
		
		return {
			left	:	amplitudeX,
			top		:	amplitudeY
		}
		
	}
	
	function galleryCreateItemCSS(itemType, augmentX, augmentY) {
		
		if (typeof augmentX === 'undefined') {
			
			var augmentX	=	0;
			
		}
		
		if (typeof augmentY === 'undefined') {
			
			var augmentY	=	0;
			
		}
		
		var output		=	{};
		
		if (itemType === 'current') {
			
			output	=	$.extend(
				{},
				galleryDetermineTranslation(currentWindowWidth / 2 - galleryCalcItemDimensions().width / 2 + augmentX, currentWindowHeight / 2 - galleryCalcItemDimensions().height / 1.5 + augmentY),
				galleryCalcItemDimensions()
			);
			
		} else if (itemType === 'prev') {
			
			output	=	$.extend(
				{},
				galleryDetermineTranslation((galleryCalcItemDimensions().width * -1 + 75) + augmentX, currentWindowHeight / 2 - galleryCalcItemDimensions().height / 1.5 + augmentY),
				galleryCalcItemDimensions()
			);
			
		} else if (itemType === 'next') {
			
			output	=	$.extend(
				{},
				galleryDetermineTranslation((currentWindowWidth - 75) + augmentX, currentWindowHeight / 2 - galleryCalcItemDimensions().height / 1.5 + augmentY),
				galleryCalcItemDimensions()
			);
			
		}
		
		return output;
		
	}
	
	function calcSwipeAmplitude(coord1, coord2) {
		
		return Math.sqrt(coord1 * coord1 + coord2 * coord2);
		
	}
	
	if ($('.photo-grid').length) {
		
		//backwards compatability for background-size:cover
		$('.photo-grid').children('.item').css('background-size', 'cover').on('click', function (event) {
			
			var $clickedItem	=	$(this),
				$prevItem		=	($clickedItem.prev().length)
										?	$clickedItem.prev()
										:	$clickedItem.siblings().eq(-1),
				$nextItem		=	($clickedItem.next().length)
										?	$clickedItem.next()
										:	$clickedItem.siblings().eq(0),
				touchData		=	[],
				$galleryWrapper	=	$('<div class="gallery-wrapper" />').on('click', function (event) {
										
										event.stopPropagation();
										
										$galleryWrapper.children('.close').trigger('click');
										
									}).on('touchstart', function (event) {
										
										if (event.originalEvent.touches.length === 1) {
											
											touchData	=	[{ x : event.originalEvent.touches[0].clientX, y : event.originalEvent.touches[0].clientY, t : new Date().getTime() }];
											
											$galleryWrapper.children('.item').css({ transitionDuration : '0ms' });
											
										}
										
									}).on('touchmove', function (event) {
										
										touchData.push({ x : event.originalEvent.touches[0].clientX, y : event.originalEvent.touches[0].clientY, t : new Date().getTime() });
										
										if (touchData.length > 2) {
											
											//determine if this is a horizontal or vertical swipe
											//if (Math.abs(touchData[0].y - touchData[touchData.length - 1].y) > 10) {
												
												//vertical swipe
												//return false;
												
											//}
											
											//swipe is horizontal
											var horizontalSwipeVector	=	touchData[touchData.length - 1].x - touchData[0].x;
											
											requestAnimationFrame(function () {
												
												$galleryWrapper.children('.item').filter('.current-item').css(galleryCreateItemCSS('current', horizontalSwipeVector, 0));
												
												if (horizontalSwipeVector > 0) {
													
													$galleryWrapper.children('.item').filter('.prev-item').css(galleryCreateItemCSS('prev', horizontalSwipeVector / 2, 0));
													
												} else {
													
													$galleryWrapper.children('.item').filter('.next-item').css(galleryCreateItemCSS('next', horizontalSwipeVector / 2, 0));
													
												}
												
											});
											
										}
										
									}).on('touchend', function (event) {
										
										var horizontalSwipeDistance	=	(touchData[touchData.length - 1].x - touchData[0].x),
											horizontalSwipeSpeed	=	horizontalSwipeDistance / (touchData[touchData.length - 1].t - touchData[0].t);
										
										$galleryWrapper.children('.item').css({ transitionDuration : '' });
										
										requestAnimationFrame(function () {
											
											if (horizontalSwipeSpeed > 0.7 || horizontalSwipeDistance > currentWindowWidth * 0.35) {
												
												//move left
												$galleryWrapper.children('.arrow').filter('.prev').trigger('click');
												
											} else if (horizontalSwipeSpeed < -0.7 || horizontalSwipeDistance < currentWindowWidth * -0.35) {
												
												//move right
												$galleryWrapper.children('.arrow').filter('.next').trigger('click');
												
											} else {
												
												//reset
												$galleryWrapper.children('.item').filter('.current-item').css(galleryCreateItemCSS('current', 0, 0));
												$galleryWrapper.children('.item').filter('.next-item').css(galleryCreateItemCSS('next', 0, 0));
												$galleryWrapper.children('.item').filter('.prev-item').css(galleryCreateItemCSS('prev', 0, 0));
												
											}
											
										});
										
									}).on('click', '.item', function (event) {
										
										event.stopPropagation();
										
										if ($(this).hasClass('prev-item')) {
											
											$galleryWrapper.children('.arrow').filter('.prev').trigger('click');
											
										} else if ($(this).hasClass('next-item')) {
											
											$galleryWrapper.children('.arrow').filter('.next').trigger('click');
											
										}
										
									})
									.append(
										$('<a class="close" href="#" />').on('click', function (event) {
											
											event.preventDefault();
											event.stopPropagation();
											
											$galleryWrapper.onCSSTransitionEnd(function () {
												
												$galleryWrapper.remove();
												
												$('html').removeClass('scrollbar-hide');
												
												$('body').height('');
												
											});
											
											$('html').removeClass('gallery-wrapper-show');
											
										})
									)
									.append(
										$('<a class="prev arrow" href="#" />').on('click', function (event) {
											
											event.preventDefault();
											event.stopPropagation();
											
											var newIndex	=	($galleryWrapper.children('.prev-item').data('gallery-index') > 0)
																	?	$galleryWrapper.children('.prev-item').data('gallery-index') - 1
																	:	$clickedItem.closest('.photo-grid').children('.item').length - 1;
											
											$galleryWrapper.children('.next-item').onCSSTransitionEnd(function () {
												
												$(this).remove();
												
											}).css({
												opacity	:	0
											});
											
											$galleryWrapper.children('.current-item').removeClass('current-item').addClass('next-item').css(galleryCreateItemCSS('next'));
											
											$galleryWrapper.children('.prev-item').removeClass('prev-item').addClass('current-item').css(galleryCreateItemCSS('current'));
											
											$galleryWrapper.append(
												$('<div class="prev-item item" />').data('gallery-index', newIndex).attr('data-caption', $clickedItem.closest('.photo-grid').children('.item').eq(newIndex).data('caption')).css({
													backgroundImage		:	'url(' + $clickedItem.closest('.photo-grid').children('.item').eq(newIndex).data('filename') + ')',
													backgroundPosition	:	$clickedItem.closest('.photo-grid').children('.item').eq(newIndex).css('background-position'),
													backgroundSize		:	'contain',
													opacity				:	0,
													transitionDelay		:	'250ms'
												}).css(galleryCreateItemCSS('prev'))
											);
											
											requestAnimationFrame(function () {
												
												$galleryWrapper.children('.prev-item').css({
													opacity				:	'',
													transitionDelay		:	''
												});
												
											});
											
										})
									)
									.append(
										$('<a class="next arrow" href="#" />').on('click', function (event) {
											
											event.preventDefault();
											event.stopPropagation();
											
											var newIndex	=	($clickedItem.closest('.photo-grid').children('.item').length > $galleryWrapper.children('.next-item').data('gallery-index') + 1)
																	?	$galleryWrapper.children('.next-item').data('gallery-index') + 1
																	:	0;
											
											$galleryWrapper.children('.prev-item').onCSSTransitionEnd(function () {
												
												$(this).remove();
												
											}).css({
												opacity	:	0
											});
											
											$galleryWrapper.children('.current-item').removeClass('current-item').addClass('prev-item').css(galleryCreateItemCSS('prev'));
											
											$galleryWrapper.children('.next-item').removeClass('next-item').addClass('current-item').css(galleryCreateItemCSS('current'));
											
											$galleryWrapper.append(
												$('<div class="next-item item" />').data('gallery-index', newIndex).attr('data-caption', $clickedItem.closest('.photo-grid').children('.item').eq(newIndex).data('caption')).css({
													backgroundImage		:	'url(' + $clickedItem.closest('.photo-grid').children('.item').eq(newIndex).data('filename') + ')',
													backgroundPosition	:	$clickedItem.closest('.photo-grid').children('.item').eq(newIndex).css('background-position'),
													backgroundSize		:	'contain',
													opacity				:	0,
													transitionDelay		:	'250ms'
												}).css(galleryCreateItemCSS('next'))
											);
											
											requestAnimationFrame(function () {
												
												$galleryWrapper.children('.next-item').css({
													opacity			:	'',
													transitionDelay	:	''
												});
												
											});
											
										})
									)
									.append(
										$('<div class="prev-item item" />').data('gallery-index', $prevItem.index()).attr('data-caption', $prevItem.data('caption')).css({
											backgroundImage		:	'url(' + $prevItem.data('filename') + ')',
											backgroundPosition	:	$prevItem.css('background-position'),
											backgroundSize		:	'contain'
										}).css(galleryCreateItemCSS('prev'))
									)
									.append(
										$('<div class="current-item item" />').data('gallery-index', $clickedItem.index()).attr('data-caption', $clickedItem.data('caption')).css({
											backgroundImage		:	'url(' + $clickedItem.data('filename') + ')',
											backgroundPosition	:	$clickedItem.css('background-position'),
											backgroundSize		:	'contain'
										}).css(galleryCreateItemCSS('current'))
									)
									.append(
										$('<div class="next-item item" />').data('gallery-index', $nextItem.index()).attr('data-caption', $nextItem.data('caption')).css({
											backgroundImage		:	'url(' + $nextItem.data('filename') + ')',
											backgroundPosition	:	$nextItem.css('background-position'),
											backgroundSize		:	'contain'
										}).css(galleryCreateItemCSS('next'))
									);
			
			$('#container').append($galleryWrapper);
			
			requestAnimationFrame(function () {
				
				$('body').height($('#content').height());
				
				$('html').addClass('gallery-wrapper-show scrollbar-hide');
				
			});
			
		});
		
	}
	
	
	
	
	
	//FORM VALIDATION
	var formValidation	=	{
			regex    		: {
				email	:	/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
			},
			message  		: {
				required	:	'This field is required',
				email		:	'Please enter a valid Email Address'
			},
			validateField	:	function ($field, runBounceAnimation) {
				
				var isError	=	false;
				
				if ($.trim($field.val()) === '') {
					
					isError		=	true;
					errorMsg	=	formValidation.message.required;
					
				} else if ($field.hasClass('validate-email') && !formValidation.regex.email.test($field.val())) {
					
					isError		=	true;
					errorMsg	=	formValidation.message.email;
					
				}
				
				if (isError) {
					
					if ($field.closest('p').find('.error-msg').length) {
						
						$field.closest('p').addClass('error');
						
						if ($field.closest('p').find('.error-msg').find('.text').text() !== errorMsg) {
							
							$field.closest('p').find('.error-msg').find('.text').stop(true, true).animate({ opacity : 0 }, 250, 'easeOutCubic', function () { $(this).text(errorMsg).stop(true, true).animate({ opacity : 1 }, 250, 'easeOutCubic'); });
							
						}
						
						if (runBounceAnimation) {
							
							$field.closest('p').find('.error-msg').onCSSAnimationEnd(function () { $(this).closest('p').removeClass('bounce'); }).end().addClass('bounce');
							
						}
						
					} else {
						
						$field.closest('p').append('<span class="error-msg"><span class="icon"></span><span class="text">' + errorMsg + '</span></span>');
						
						requestAnimationFrame(function () {
							
							$field.closest('p').addClass('error');
							
						});
						
					}
					
				} else {
					
					$field.closest('p').find('.error-msg').onCSSTransitionEnd(function () { $(this).remove(); }).end().removeClass('error bounce');
					
				}
				
				return isError;
				
			}
		};
	$('form').data('has-submitted', false).on('submit', function (event) {
		
		event.preventDefault();
		
		var errors		=	false,
			$form		=	$(this),
			$firstError	=	$();
		
		$form.data('has-submitted', true);
		
		$.each($form.find('input, select, textarea').filter('.required'), function () {
			
			var innerError	=	formValidation.validateField($(this), true);
			
			if (innerError) {
				
				if (!errors) {
					
					$firstError	=	$(this);
					
				}
				
				errors	=	true;
				
			}
			
		});
		
		if (errors) {
			
			$form.find('input[type=submit]').closest('p').addClass('error');
			
			var topMostErrorPos	=	$firstError.offset().top;
			
			if (topMostErrorPos < currentScrollPosition + currentHeaderHeight) {
				
				var scrollToPos	=	topMostErrorPos - currentHeaderHeight - 50;
				
				if ($('html').hasClass('ui-mobile')) {
					
					scrollToPos	=	topMostErrorPos - 50
					
				}
				
				$('html, body').animate({ scrollTop : scrollToPos }, 250, 'easeOutCubic');
				
			}
			
			$firstError.focus().select();
			
		} else {
			
			$form.find('input[type=submit]').closest('p').removeClass('error');
			
			if ($form.find('[name=subject]').val() === 'Other') {
				
				$form.find('[name=subject]').replaceWith(
					$('<input name="subject" type="text" />').val($form.find('[name="subject-other"]').val())
				);
				
			}
			
			$form.find('[name="subject-other"]').remove();
			
			if ('ga' in window) {
        window.ga('send', 'event', 'Form', 'Submission', 'Contact');
      }
      if ('gtag' in window) {
        window.gtag('event', 'Submission', {
          event_category: 'Form',
          event_label: 'Contact'
        });
      }
			
			$.ajax({
				url			:	$form.attr('action'),
				type		:	$form.attr('method'),
				dataType	:	'html',
				data		:	$form.serialize(),
				success		:	function (response) {
					
					//if (response.STATUS === 'SUCCESS') {
						
						var $response	=	$('<p>' + response + '</p>');
						
						$form.after($response);
						
						requestAnimationFrame(function () {
							
							$form.slideUp(350, 'easeInOutCubic');
							$response.slideDown(350, 'easeInOutCubic');
							
						});
						
					//}
					
				},
				error		:	function (a, b, c) {
					
					if (typeof console === 'object' && typeof console.log !== 'undefined') {

						console.log(a);
						console.log(b);
						console.log(c);
						
					}
					
				}
			});
			
		}
		
	}).find('input, textarea, select').on('blur', function () {
		
		if ($(this).val() === '') {
			
			$(this).closest('p').removeClass('active');
			
		}
		
	}).on('focus', function () {
		
		$(this).closest('p').addClass('active').find('select').trigger('mousedown');
		
	}).on('change keyup paste', function () {
		
		if ($(this).closest('form').data('has-submitted')) {
		
			formValidation.validateField($(this), false);
			
		}
		
	}).filter('select').on('change', function () {
		
		if ($(this).closest('label').data('other-id') && $(this).val() === 'Other') {
			
			$('#' + $(this).closest('label').data('other-id')).slideDown(250, 'easeOutCubic').find('input').addClass('required');
			
		} else {
			
			$('#' + $(this).closest('label').data('other-id')).slideUp(250, 'easeOutCubic', function () {
				
				$(this).find('input').val('');
				
			}).find('input').removeClass('required');
			
		}
		
		if ($(this).val() === 'Availability') {
			
			$(this).closest('form').find('input, select, textarea').not(this).prop('disabled', true);
			
			if ($(this).closest('label').data('notice-id')) {
				
				$('#' + $(this).closest('label').data('notice-id')).slideDown(250, 'easeOutCubic');
				
			}
			
		} else {
			
			$(this).closest('form').find('input, select, textarea').removeProp('disabled');
			
			if ($(this).closest('label').data('notice-id')) {
				
				$('#' + $(this).closest('label').data('notice-id')).slideUp(250, 'easeOutCubic');
				
			}
			
		}
		
	}).end().end().on('click', '.error-msg', function () {
		
		$(this).closest('p').removeClass('error bounce').find('input, select, textarea').focus().select();
		
	});
	
	
	
	
	
	
	//setup GA tracking code
	window.pepTracking	= {
		page	: function (customPage) {
			if (typeof customPage === 'string' && customPage !== '') {
				var localGAQ	= window._gaq	|| [];
				localGAQ.push(['_trackPageview', customPage]);
			}
		},
		event	: function (category, action, extra, value, ni) {
			if (typeof category !== 'string') {
				category	= 'N/A';
			}
			if (typeof action !== 'string') {
				action	= 'N/A';
			}
			if (typeof extra !== 'string') {
				extra	= 'N/A';
			}
			if (typeof value !== 'integer') {
				value	= 0;
			}
			if (typeof ni !== 'boolean') {
				ni	= false;
			}
			var localGAQ	= window._gaq	|| [];
			localGAQ.push(['_trackEvent', category, action, extra, value, ni]);
		}
	};
	
	$("#body").find('.track-click').on("click", function () {
		window.pepTracking.page($(this).attr('href'));
	});
	
	
	
	
	
	
	//setup helper functions
	if (typeof String.prototype.trimLeft !== "function") {
		String.prototype.trimLeft = function() {
			return this.replace(/^\s+/, "");
		};
	}
	if (typeof String.prototype.trimRight !== "function") {
		String.prototype.trimRight = function() {
			return this.replace(/\s+$/, "");
		};
	}
	if (typeof Array.prototype.map !== "function") {
		Array.prototype.map = function(callback, thisArg) {
			for (var i=0, n=this.length, a=[]; i<n; i++) {
				if (i in this) a[i] = callback.call(thisArg, this[i]);
			}
			return a;
		};
	}
	function getCookies() {
		var c = document.cookie, v = 0, cookies = {};
		if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
			c = RegExp.$1;
			v = 1;
		}
		if (v === 0) {
			c.split(/[,;]/).map(function(cookie) {
				var parts = cookie.split(/=/, 2),
					name = decodeURIComponent(parts[0].trimLeft()),
					value = parts.length > 1 ? decodeURIComponent(parts[1].trimRight()) : null;
				cookies[name] = value;
			});
		} else {
			c.match(/(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x00-\x7F])*")(?=\s*[,;]|$)/g).map(function($0, $1) {
				var name = $0,
					value = $1.charAt(0) === '"'
							  ? $1.substr(1, -1).replace(/\\(.)/g, "$1")
							  : $1;
				cookies[name] = value;
			});
		}
		return cookies;
	}
	function getCookie(name) {
		return getCookies()[name];
	}
	
})(jQuery);
